import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    GetRuleGroups,
    DeleteRuleGroup,
    CreateNewRulesConfiguration,
    GetSingleRulesGroupConfiguration,
    SaveSingleRulesGroupConfiguration,
    GetGroupedRuleConfiguration,
    SaveGroupedRuleConfiguration,
    GetSingleRule,
    GetRuleValues,
    DeleteRule,
    AddRule,
    AddBulkRules,
    SaveRule,
    SaveBulkRule,
    AddGroupedRule,
    DeleteGroupedRule,
    UpdateCopyRules,
    MoveCopyRules,
    CreateRules,
    DeleteRules
};

function GetRuleGroups(contractId, versionId, editionId, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function GetSingleRulesGroupConfiguration(contractId, versionId, editionId, rulesGroupConfigId, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${rulesGroupConfigId}`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function GetSingleRule(contractId, versionId, editionId, rulesGroupConfigId, ruleId, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${rulesGroupConfigId}/rules/${ruleId}`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function SaveSingleRulesGroupConfiguration(contractId, versionId, editionId, rulesGroupConfigId, ruleToSave, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${rulesGroupConfigId}`, ruleToSave, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function DeleteRuleGroup(contractId, versionId, editionId, rulesGroupConfigId, onSuccess, onError){

    var headers = getAuthHeader();
    axios
        .delete(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${rulesGroupConfigId}`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function CreateNewRulesConfiguration(contractId, versionId, editionId, newRuleConfigurationObject, onSuccess, onError){

    var headers = getAuthHeader();
    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations`, newRuleConfigurationObject, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function AddRule(contractId, versionId, editionId, ruleConfigurationId, ruleToSave, onSuccess, onError){

    var headers = getAuthHeader();

    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${ruleConfigurationId}/rules`, ruleToSave, headers)
        .then((response) => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function AddBulkRules(contractId, versionId, editionId, ruleConfigurationId, rulesToAdd, onEachSuccess, onFinalSuccess, onError){

    var headers = getAuthHeader();
    let ruleToAdd = rulesToAdd[0];
    let remainingRules = rulesToAdd.slice(1, rulesToAdd.length);
    let result = [];
    let errors = [];

    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${ruleConfigurationId}/rules`, ruleToAdd, headers)
        .then((response) => {
            onEachSuccess(response.data);
            result = result.concat(response.data);
            if(remainingRules.length > 0){
                AddBulkRules(
                    contractId,
                    versionId,
                    editionId,
                    ruleConfigurationId,
                    remainingRules,
                    onEachSuccess,
                    (innerResponse) => {
                        result = result.concat(innerResponse);
                        onFinalSuccess(result);
                    },
                    (error) => {
                        error.push(error);
                        onError(errors)
                    }
                );
            }
            else{
                onFinalSuccess(result);
            }
            
        })
        .catch(error => {
            error.push(error);
            onError(errors);
        });
}

function SaveRule(contractId, versionId, editionId, ruleConfigurationId, ruleToSave, onSuccess, onError){

    var headers = getAuthHeader();

    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${ruleConfigurationId}/rules/${ruleToSave.id}`, ruleToSave, headers)
        .then(() => {
            onSuccess(); 
        })
        .catch(error => {
            onError(error);
        });
}

function SaveBulkRule(contractId, versionId, editionId, ruleConfigurationId, rulesToSave, onSuccess, onError){

    var headers = getAuthHeader();
    let ruleToSave = rulesToSave[0];
    let remainingRules = rulesToSave.slice(1, rulesToSave.length)
    let result = [];
    let errors = [];

    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${ruleConfigurationId}/rules/${ruleToSave.id}`, ruleToSave, headers)
        .then((response) => {
            result = result.concat(response.data);
            if(remainingRules.length > 0){
                SaveBulkRule(
                    contractId,
                    versionId,
                    editionId,
                    ruleConfigurationId,
                    remainingRules,
                    (innerResponse) => {
                        result = result.concat(innerResponse);
                        onSuccess(result);
                    },
                    (error) => {
                        error.push(error);
                        onError(errors)
                    }
                );
            }
            else{
                onSuccess(result);
            }
            
        })
        .catch(error => {
            error.push(error);
            onError(errors);
        });
}

function AddGroupedRule(contractId, versionId, editionId, ruleConfigurationId, newRuleConfigurationObject, onSuccess, onError){

    var headers = getAuthHeader();

    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${ruleConfigurationId}/rulegroups`, newRuleConfigurationObject, headers)
        .then((response) => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function DeleteGroupedRule(contractId, versionId, editionId, ruleConfigurationId, groupingId, onSuccess, onError){

    var headers = getAuthHeader();
    
    axios
    .delete(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${ruleConfigurationId}/rulegroups/${groupingId}`, headers)
    .then(() => {
            onSuccess(); 
        })
        .catch(error => {
            onError(error);
        });
}


function GetRuleValues(contractId, versionId, editionId, configId, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${configId}/rules`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error); 
        });
}

function GetGroupedRuleConfiguration(contractId, versionId, editionId, configId, groupedRuleId, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${configId}/rulegroups/${groupedRuleId}`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function SaveGroupedRuleConfiguration(contractId, versionId, editionId, configId, groupedRuleId, configuration, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${configId}/rulegroups/${groupedRuleId}`, configuration, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function DeleteRule(contractId, versionId, editionId, configId, ruleId, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .delete(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${configId}/rules/${ruleId}`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}

function UpdateCopyRules(contractId, versionId, editionId, configId, ruleUpdateObject, copy, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${configId}/rules?copy=${copy}`, ruleUpdateObject, headers)
        .then(() => {
            onSuccess(); 
        })
        .catch(error => {
            onError(error);
        });
}

function MoveCopyRules(contractId, versionId, editionId, configId, ruleUpdateObject, onSuccess, onError){
    var headers = getAuthHeader();
    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${configId}/rules/copyormove`, ruleUpdateObject, headers)
        .then(() => {
            onSuccess(); 
        })
        .catch(error => {
            onError(error);
        });
}

function CreateRules(contractId, versionId, editionId, configId, ruleUpdateObject, onSuccess, onError){
    
    var headers = getAuthHeader();
    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${configId}/rules`, ruleUpdateObject, headers)
        .then(() => {
            onSuccess(); 
        })
        .catch(error => {
            onError(error);
        });
}

function DeleteRules(contractId, versionId, editionId, configId, rulesToDelete, onSuccess, onError){

    // Axios requires the data to be in the Headers-Data object when deleting
    var headers = getAuthHeader();
    headers.data = rulesToDelete;
    axios
        .delete(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/ruleconfigurations/${configId}/rules`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}
